import Vue from 'vue'
import router from './router'

import "../../plugins/axios.js";
import '../../element-ui'
import '../../assets/icon/iconfont.css'
import '../../assets/icon/iconfont.js'
import LayoutSidebar from '../../components/layout_sidebar.vue';

Vue.component("layout-sidebar", LayoutSidebar);

import main from './main.vue'
import common from "../../common/common"

Vue.use(common)

Vue.use(require('vue-wechat-title'))


new Vue({
    router,
    render: h => h(main)
}).$mount('#app')